import React from 'react'
import PropTypes from 'prop-types'
import { CALENDAR_DATETIME_FORMAT } from 'commons/js/constants'
import { BookingProductType } from 'parking-availability/js/propTypes'
import DateTime from 'commons/js/ui/DateTime'
import { Copy, Button, Flex, Box, Icon, Currency } from '@elparking/components'

import styled from 'styled-components'

const Container = styled(Box)`
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
`

class ResumeBlock extends React.Component {
    static propTypes = {
        startDate: PropTypes.number.isRequired,
        endDate: PropTypes.number.isRequired,
        bookingProduct: BookingProductType,
        onClick: PropTypes.func,
        showProduct: PropTypes.bool,
    }

    static defaultProps = {
        onClick: () => {},
        bookingProduct: null,
    }

    renderPrice () {
        const { priceQty } = this.props.bookingProduct.availability
        return <Currency qty={priceQty} />
    }

    render () {
        const { startDate, endDate, bookingProduct, onClick, showProduct } = this.props
        const { parkingName } = bookingProduct
        const { name } = bookingProduct.product
        return (
            <Container p='1em' bg='lightGray20'>
                <Flex w='100%' flexWrap='wrap' justifyContent='space-between'>
                    <Box flex='1' style={{ minWidth: 0 }}>
                        <Copy.truncate size='small' fontWeight='medium' padding='0'>
                            {parkingName}
                        </Copy.truncate>
                    </Box>
                    <Box flex='0 1 auto'>
                        <Button.unstyled onClick={onClick}>
                            <Icon type='arrow-up' color='main' size='xLarge' />
                        </Button.unstyled>
                    </Box>
                </Flex>
                <Copy.truncate size='small' fontWeight='regular' padding='0'>
                    <DateTime value={startDate} format={CALENDAR_DATETIME_FORMAT} />
                    <span> - </span>
                    <DateTime value={endDate} format={CALENDAR_DATETIME_FORMAT} />
                    <Copy as='span' color='gray20'> | </Copy>
                    {showProduct && name} {this.renderPrice()}
                </Copy.truncate>
            </Container>
        )
    }
}

export default ResumeBlock
